import { App as AntApp, ConfigProvider } from 'antd';
import { ScrollToTop } from 'components';
import { AuthContextProvider } from 'contexts/AuthContext';
import { HomeSessionProvider } from 'contexts/HomeSessionContext';
import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useLocation } from 'react-router';
import Routes from 'routes';
import appTheme from 'theme/theme';
import * as Userpilot from 'tools/Userpilot';
import 'translations';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retryDelay: 30 * 1000,
      retry: process.env.NODE_ENV !== 'development',
    },
    mutations: {
      retry: false,
    },
  },
});

export default function App() {
  const location = useLocation();

  React.useEffect(() => {
    Userpilot.reload();
  }, [location]);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider {...appTheme}>
        <AntApp>
          <AuthContextProvider>
            <HomeSessionProvider>
              <ScrollToTop />
              <Routes />
            </HomeSessionProvider>
          </AuthContextProvider>
        </AntApp>
      </ConfigProvider>
    </QueryClientProvider>
  );
}
